module.exports = __webpack_public_path__ + "static/media/answer_right.49ebb682.mp3";